
import React, { PropsWithChildren } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from './ThemeProvider'
import ErrorBoundary from './ErrorBoundary'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from '@/components/ui/toaster'
import { AuthProvider } from '@/hooks/useAuth'
import { I18nextProvider } from 'react-i18next'
import i18n from '@/lib/i18n'
import { TranslationEditProvider } from '@/contexts/TranslationEditContext'
import { FeatureFlagsProvider } from '@/contexts/FeatureFlagsContext'
import { PlanSelectDialogProvider } from '@/contexts/PlanSelectDialogContext'

// Create a client with proper retry and stale time configuration
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 3,
      retryDelay: 1000,
    },
  },
})

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <I18nextProvider i18n={i18n}>
              <AuthProvider>
                <FeatureFlagsProvider>
                  <TranslationEditProvider>
                    <PlanSelectDialogProvider>
                      {children}
                      <Toaster />
                    </PlanSelectDialogProvider>
                  </TranslationEditProvider>
                </FeatureFlagsProvider>
              </AuthProvider>
            </I18nextProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </ErrorBoundary>
  )
}
